import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/dashboardThemes'
import Component from 'components/DashboardThemes'

export default createListViewContainer({ actions, selectors: selectors.dashboardThemes })(Component)
